export const shellyConfig = {
  common: {
    saving: "Wird gespeichert...",
    online: "Online",
    offline: "Offline",
  },

  step1: {
    title: "Shelly-Einrichtung",
    subtitle:
      "Verbinden Sie Ihr Shelly Cloud-Konto, um Ihre Relais zu steuern (elektrische Türöffner, Tore usw.).",
    connected: "Konto verbunden",
    notConnected: "Nicht verbunden",
    credentialsInfo:
      "Ihre Zugangsdaten finden Sie in der Shelly-App: <b>User settings → Cloud authorization key</b>. Dort sehen Sie die <b>Server URI</b> und können Ihren <b>Auth Key</b> erzeugen.",
    serverUriPlaceholder: "z. B. shelly-103-eu.shelly.cloud",
    serverUriHelp: "Cloud-Server, der Ihrem Shelly-Konto zugewiesen ist.",
    authKeyPlaceholderSaved: "•••••••• (bereits gespeichert, Änderung optional)",
    authKeyPlaceholderNew: "Fügen Sie Ihren Cloud Authorization Key ein",
    authKeyHelpSaved: "Sie können das Feld leer lassen, wenn bereits ein Schlüssel gespeichert ist.",
    authKeyHelpNew:
      "Mit diesem Schlüssel steuern Sie Ihre Geräte: Bewahren Sie ihn sicher auf.",
    testing: "Wird getestet...",
    testConnection: "Verbindung testen",
    saveCredentials: "Zugangsdaten speichern",
  },

  step2: {
    title: "Geräteauswahl für diese Unterkunft",
    subtitle:
      "Wählen Sie nur die Shelly-Relais aus, die für <b>diese Unterkunft</b> gelten. Im PMS sehen Sie dann nur die ausgewählten.",
    selectedCount: "{count} ausgewählt",
    hintCredentials:
      "Geben Sie Ihre Server URI und Ihren Auth Key ein und klicken Sie auf <b>Verbindung testen</b>, um Ihre Geräte zu laden.",
    noDevices: "In Ihrem Shelly-Konto wurden keine Geräte gefunden.",
    selectPlaceholder: "Geräte auswählen…",
    devicesSelected: "{count} Gerät(e) ausgewählt",
    noneSelected: "Keine Geräte ausgewählt",
    channels: "{count} Kanäle",
    saveDevices: "Geräte für diese Unterkunft speichern",
  },

  step3: {
    title: "Steuerung und Zuweisung (PMS)",
    subtitle:
      "Weisen Sie jedes Relais <b>Haupttür</b>, <b>Einheit</b> oder <b>Tor</b> zu und legen Sie den Öffnungsimpuls fest.",
    assignedCount: "{count} zugewiesen",
    noSavedDevices:
      "Für diese Unterkunft sind noch keine Geräte gespeichert. Verwenden Sie oben die <b>Auswahl</b> und speichern Sie anschließend.",
    pulseInfo:
      "<b>Öffnen</b> sendet einen Impuls an das Relais (es schaltet sich nach den konfigurierten Sekunden von selbst wieder aus): ideal für elektrische Türöffner und Tore. Shelly erzeugt keine PIN-Codes.",
    open: "Öffnen",
    openTooltip: "Öffnen (Impuls)",
    turnOnTooltip: "Relais einschalten",
    turnOffTooltip: "Relais ausschalten",
    refreshTooltip: "Status aktualisieren",
    assignment: "Zuweisung",
    assignNone: "Nicht zugewiesen",
    assignCommon: "Haupttür (gemeinsam)",
    assignUnit: "Wohnungstür",
    assignGate: "Tor / Garage",
    hintNone: "Es wird nicht über das PMS gesteuert.",
    hintAssigned: "Es wird für die Fernöffnung mit dieser Unterkunft verknüpft.",
    unitLabel: "Einheit / Unterkunft",
    selectUnit: "Einheit auswählen",
    unitFallback: "Einheit {id}",
    selectUnitHint: "Wählen Sie, welche Einheit dieses Relais öffnet.",
    channelLabel: "Relais-Kanal",
    channelOption: "Kanal {n}",
    channelHint: "Kanal, der mit dem Schloss verdrahtet ist (Geräte mit mehreren Relais).",
    pulseLabel: "Öffnungsimpuls (Sekunden)",
    pulseHint: "Wie lange das Relais beim Öffnen eingeschaltet bleibt.",
    nameLabel: "Name (optional)",
    namePlaceholder: "z. B. Haupttür / Apt. 101",
    nameHint: "Name, der im PMS für dieses Gerät angezeigt wird.",
    saveAssignment: "Zuweisung speichern",
    tip:
      "Tipp: Weisen Sie jedes Relais zu und klicken Sie auf <b>Zuweisung speichern</b>. Die Steuertasten werden aktiviert, sobald das Gerät zugewiesen ist.",
  },

  toast: {
    loadDevicesFailed: "Geräte konnten nicht geladen werden",
    loadDevicesError: "Fehler beim Laden der Geräte",
    missingCredentials: "Sie müssen die Server URI und Ihren Shelly Auth Key eingeben.",
    connectionSuccess:
      "Verbindung erfolgreich. {count} Gerät(e) gefunden.",
    testError: "Fehler beim Testen der Verbindung",
    invalidAuthKey: "Sie müssen einen gültigen Auth Key eingeben (mindestens 10 Zeichen).",
    missingServerUri: "Sie müssen die Server URI Ihres Shelly-Kontos eingeben.",
    credentialsSaved: "Zugangsdaten erfolgreich gespeichert",
    credentialsError: "Fehler beim Speichern der Zugangsdaten",
    credentialsSaveError: "Fehler beim Speichern der Zugangsdaten: {error}",
    selectAtLeastOne:
      "Sie müssen mindestens ein Gerät für diese Unterkunft auswählen.",
    devicesSaved: "Geräte für diese Unterkunft gespeichert",
    devicesSaveFailed: "Geräte konnten nicht gespeichert werden",
    saveError: "Fehler beim Speichern: {error}",
    selectUnitForApartment:
      "Wählen Sie die Einheit für Relais aus, die als 'Wohnungstür' zugewiesen sind.",
    assignmentFailed: "Die Zuweisung konnte nicht gespeichert werden",
    assignmentSaved: "Zuweisung erfolgreich gespeichert",
    assignmentSaveError: "Fehler beim Speichern der Zuweisung: {error}",
    opOpen: "Öffnungsbefehl gesendet (Relais-Impuls)",
    opOn: "Relais eingeschaltet",
    opOff: "Relais ausgeschaltet",
    opDone: "Aktion abgeschlossen",
    opFailed: "Die Aktion konnte nicht abgeschlossen werden",
    opError: "Fehler beim Ausführen der Aktion",
  },
};
